import request from '@/utils/request'
import env from '@/env'
export function getNewsList (params: any) {
    return request({
        url: env.testUrlWeb + '/journalism/journalismQuery',
        method: 'POST',
        data: params,
    })
}
export function getNewsTabsList (params: any) {
    return request({
        url: env.testUrlWeb + '/specialColumnType/specialColumnTypeQuery',
        method: 'POST',
        data: params,
    })
}
export function getNewsColumnList (params: any) {
    return request({
        url: env.testUrlWeb + '/specialColumn/specialColumnQuery',
        method: 'POST',
        data: params,
    })
}